module.exports = __webpack_public_path__ + "static/03-analyze-b80f9d0c348064f053c586eee1a504b6.jpg";